import React from 'react'
import './list.css'

const List = ({ text, lable, confidence, index }) => {

    var ll;
    if (lable === '+') {
        ll = true 
        lable='Positive'
    }
    else {
        ll = false 
        lable='Negetive'
    }

    return (
        
            <div className="container-wrapper"  key={index}>

                <div className={`card mt-4 ${ll ? 'pos' : 'neg'}`}>

                    <p>{text}</p>
                    <p className="mt-2">Label : {lable}</p>
                    <p className="mt-2">Confidence: {confidence * 100} %</p>
                </div>
            </div>
        
    )
}

export default List
